import { request } from '@/utils/request';
import ENDPOINT from "@/config/endpoint";


function getFeatureFlags() {
  return request({
    url: ENDPOINT.FEATURE_FLAGS_BACKEND,
    method: 'get',
  });
}

export default {
  getFeatureFlags,
};
